import BuiltInWidgetByText from './components/text';
import BuiltInWidgetByEcharts from './components/echarts';

export default {
  BuiltInWidgetByText,
  BuiltInWidgetByEcharts
}